import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { LoginComponent } from '../app/login/login.component';
import { HomeComponent } from '../app/home/home.component';

import { AuthGuard } from './services/auth/auth.guard';
import { ForgotpasswordComponent } from './login/forgotpassword/forgotpassword.component';
import { FooterModule } from './front/footer/footer.module';
import { AboutUsComponent } from './front/footer/about-us/about-us.component';
import { ContactUsComponent } from './front/footer/contact-us/contact-us.component';
import { FAQComponent } from './front/footer/faq/faq.component';
import { ActRulesComponent } from './front/footer/act-rules/act-rules.component';
import { PSGActComponent } from './front/footer/psgact/psgact.component';
import { FeedBackComponent } from './front/footer/feed-back/feed-back.component';
import { AccessDeniedComponent } from './login/access-denied/access-denied.component';
import { bylawsGuard } from './services/auth/guards/bylaws.guard';
import { LoginGuard } from './services/auth/guards/login.guard';




import { userAccessGuard } from './services/auth/guards/user-access.guard';
import { CooperativeSocietiesComponent } from './cooperative-societies/cooperative-societies.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { RegistrationComponent } from './login/registration/registration.component';
import { CalendarComponent } from './front/footer/calendar/calendar.component';
import { OCRComponent } from './clone/ocr/ocr.component';
import { RcsUpdateComponent } from './clone/rcs-update/rcs-update.component';
import { AllNotificationsComponent } from './home/all-notifications/all-notifications.component';

const routes: Routes = [

  { path: 'starter', component: HomeComponent },

  // {
  //   path: '',
  //   component: HomeComponent,
  // },
 
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'societyRegistration',
    component: RegistrationComponent,
  },
  
  {
    path: 'forgotpassword',
    component: ForgotpasswordComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: '',
    component: FullComponent,

    children: [
     { path: '', redirectTo: '/home', pathMatch: 'full' },
       { path: 'notifications', component: AllNotificationsComponent },
      {
        path: 'user-profile',
        component: UserprofileComponent,
        canActivate: [AuthGuard],
        data: { title: 'user-profile', description: 'user-profile' },
      },
      {path:'NcdUpdate',component:RcsUpdateComponent},
      {
        path: 'home',
        loadChildren: () =>
          import('../app/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'menu',
        loadChildren: () =>
          import('./menu/menu.module').then((m) => m.MenuModule),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./features/user/user.module').then((m) => m.UserModule),
        canMatch: [userAccessGuard],
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
         canMatch: [userAccessGuard],
      },
      {
        path: 'society',
        loadChildren: () =>
          import('./features/society/society.module').then(
            (m) => m.SocietyModule
          ),
        canMatch: [],
      },
      {
        path: 'dashboard',

        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
        canMatch: [userAccessGuard],



      },

      {
        path: 'about',
        loadChildren: () =>
          import('./about/about.module').then((m) => m.AboutModule),
        canMatch: [userAccessGuard],
      },
      {
        path: 'component',
        loadChildren: () =>
          import('./component/component.module').then(
            (m) => m.ComponentsModule
          ),
        // canMatch: [userAccessGuard],
      },
      {
        path: 'audit',

        loadChildren: () =>
          import('./audit/audit.module').then((m) => m.AuditModule)



      },

      {
        path: 'allot',
        loadChildren: () =>
          import('./allot-auditor/allot-auditor.module').then(
            (m) => m.AllotAuditorModule
          ),
        canMatch: [userAccessGuard],
        canActivate: [AuthGuard],
      },
      {
        path: 'allot/:id',
        loadChildren: () =>
          import('./allot-auditor/allot-auditor.module').then(
            (m) => m.AllotAuditorModule
          ),
        canMatch: [userAccessGuard],
        canActivate: [AuthGuard],
      },

      {
        path: 'election',
        loadChildren: () =>
          import('./features/election/election.module').then(
            (m) => m.ElectionModule
          ),
        canMatch: [userAccessGuard],
        canActivate: [AuthGuard],
      },
      {
        path: 'liquidation',
        loadChildren: () =>
          import('./liquidation/liquidation/liquidation.module').then(
            (m) => m.LiquidationModule
          ),
        canMatch: [userAccessGuard],
      },


      {
        path: 'bylaws',
        loadChildren: () =>
          import('./bylaws/bylaws.module').then((m) => m.BylawsModule),
        // canActivate: [bylawsGuard],
        canMatch: [userAccessGuard],
      },
      {
        path: 'aboutdepartment',
        loadChildren: () =>
          import('./front/AboutDepartment/aboutdepartment.module').then(
            (m) => m.AboutDepartmentModule
          )

      },

      // { path: 'bylaws', loadChildren: () => import('./bylaws/bylaws.module').then(m => m.BylawsModule),
        //  canActivate: [bylawsGuard], 
        //  canMatch: [userAccessGuard] },
      { path: 'aboutdepartment', loadChildren: () => import('./front/AboutDepartment/aboutdepartment.module').then(m => m.AboutDepartmentModule) },

      { path: 'rti', loadChildren: () => import('./front/rti/rti.module').then(m => m.RTIModule) },


      {
        path: 'rti',
        loadChildren: () =>
          import('./front/rti/rti.module').then((m) => m.RTIModule),
        // canMatch: [userAccessGuard],
      },

      {
        path: 'courtcases',
        loadChildren: () =>
          import('./front/courtcases/courtcases.module').then(
            (m) => m.CourtcasesModule
          ),
        // canMatch: [userAccessGuard],
      },

      {
        path: 'audit',
        loadChildren: () =>
          import('./front/audit/audit.module').then((m) => m.AuditModule)
        //,
        // canMatch: [userAccessGuard],
      },

      // {
      //   path: 'audit',
      //   loadChildren: () =>
      //     import('./front/audit/audit.module').then((m) => m.AuditModule),
      //   canMatch: [userAccessGuard],
      // },



      {
        path: 'actionplan',
        loadChildren: () =>
          import('./front/action-plan/action-plan.module').then(
            (m) => m.ActionPlanModule
          )
        //   ,
        // canMatch: [userAccessGuard],
      },

      { path: 'societyregistration', loadChildren: () => import('./front/society-registration/society-registration.module').then(m => m.SocietyRegistrationModule) },
      { path: 'aboutus', component: AboutUsComponent },
      { path: 'contact', component: ContactUsComponent },
      { path: 'faq', component: FAQComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'actrules', component: ActRulesComponent },
      { path: 'psgact', component: PSGActComponent },
      { path: 'FeedBack', component: FeedBackComponent },
  { path: 'CooperativeSocieties', component: CooperativeSocietiesComponent },

      {
        path: 'societyregistration',
        loadChildren: () =>
          import(
            './front/society-registration/society-registration.module'
          ).then((m) => m.SocietyRegistrationModule)
        //,
        // canMatch: [userAccessGuard],
      },
      { path: 'legalAction', loadChildren: () => import('./legal-action/legal-action.module').then(m => m.LegalActionModule) },
      { path: 'enquiry', loadChildren: () => import('./enquiry/enquiry.module').then(m => m.EnquiryModule) },
        { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },
      { path: 'aboutus', component: AboutUsComponent },
      { path: 'contact', component: ContactUsComponent },
      { path: 'faq', component: FAQComponent },
      { path: 'actrules', component: ActRulesComponent },
      { path: 'psgact', component: PSGActComponent },
      { path: 'FeedBack', component: FeedBackComponent },
      { path: 'calender', component: CalendarComponent },

       { path: 'backlog', loadChildren: () => import('./backlog/backlog.module').then(m => m.BacklogModule) },

    ],
  },

 { path: 'ocr', component: OCRComponent },

 



  {

    path: '**',
    redirectTo: '/home',
  },
];
@NgModule({
  imports: [RouterModule, RouterModule.forRoot(routes, { useHash: true , 
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled' // optional (for #section links)
    })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
